var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControlCenterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3335 30.5002C28.3335 31.4206 29.0797 32.1668 30.0002 32.1668C30.9206 32.1668 31.6668 31.4206 31.6668 30.5002C31.6668 29.5797 30.9206 28.8335 30.0002 28.8335C29.0797 28.8335 28.3335 29.5797 28.3335 30.5002Z",
    stroke: "#024064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 30.5002C18.3335 31.4206 19.0797 32.1668 20.0002 32.1668C20.9206 32.1668 21.6668 31.4206 21.6668 30.5002C21.6668 29.5797 20.9206 28.8335 20.0002 28.8335C19.0797 28.8335 18.3335 29.5797 18.3335 30.5002Z",
    stroke: "#024064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 30.5002C8.3335 31.4206 9.07969 32.1668 10.0002 32.1668C10.9206 32.1668 11.6668 31.4206 11.6668 30.5002C11.6668 29.5797 10.9206 28.8335 10.0002 28.8335C9.07969 28.8335 8.3335 29.5797 8.3335 30.5002Z",
    stroke: "#024064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3335 20.5002C28.3335 21.4206 29.0797 22.1668 30.0002 22.1668C30.9206 22.1668 31.6668 21.4206 31.6668 20.5002C31.6668 19.5797 30.9206 18.8335 30.0002 18.8335C29.0797 18.8335 28.3335 19.5797 28.3335 20.5002Z",
    stroke: "#024064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 20.5002C18.3335 21.4206 19.0797 22.1668 20.0002 22.1668C20.9206 22.1668 21.6668 21.4206 21.6668 20.5002C21.6668 19.5797 20.9206 18.8335 20.0002 18.8335C19.0797 18.8335 18.3335 19.5797 18.3335 20.5002Z",
    stroke: "#024064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 20.5002C8.3335 21.4206 9.07969 22.1668 10.0002 22.1668C10.9206 22.1668 11.6668 21.4206 11.6668 20.5002C11.6668 19.5797 10.9206 18.8335 10.0002 18.8335C9.07969 18.8335 8.3335 19.5797 8.3335 20.5002Z",
    stroke: "#024064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3335 10.5002C28.3335 11.4206 29.0797 12.1668 30.0002 12.1668C30.9206 12.1668 31.6668 11.4206 31.6668 10.5002C31.6668 9.57969 30.9206 8.8335 30.0002 8.8335C29.0797 8.8335 28.3335 9.57969 28.3335 10.5002Z",
    stroke: "#024064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 10.5002C18.3335 11.4206 19.0797 12.1668 20.0002 12.1668C20.9206 12.1668 21.6668 11.4206 21.6668 10.5002C21.6668 9.57969 20.9206 8.8335 20.0002 8.8335C19.0797 8.8335 18.3335 9.57969 18.3335 10.5002Z",
    stroke: "#024064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 10.5002C8.3335 11.4206 9.07969 12.1668 10.0002 12.1668C10.9206 12.1668 11.6668 11.4206 11.6668 10.5002C11.6668 9.57969 10.9206 8.8335 10.0002 8.8335C9.07969 8.8335 8.3335 9.57969 8.3335 10.5002Z",
    stroke: "#024064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlCenterIcon);
export default __webpack_public_path__ + "static/media/ControlCenterIcon.da4b7e0a91149c9b582ba620b9c402d9.svg";
export { ForwardRef as ReactComponent };